export default __webpack_public_path__ + "media/images/images/backgrounds/laptop-cefe8813c03e7ddf683b27c3f01ebdb3.jpg";